import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Udacity - learn how to give an autonomous car its brain",
  "description": "",
  "published": "2012-02-06T00:00:00.000Z",
  "redirect_from": ["/blog/udacity-learn-how-to-give-an-autonomous-car-its-brain/swizec/3627"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few days ago an email birdie delivered this amazing piece of news:`}</p>
    <lite-youtube {...{
      "videoid": "bdCnb0EFAzk",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`In short, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Sebastian_Thrun",
        "title": "Sebastian Thrun"
      }}>{`Sebastian Thrun`}</a>{` of `}<a parentName="p" {...{
        "href": "http://ai-class.com"
      }}>{`ai-class.com`}</a>{`, `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.43,-122.17&spn=0.01,0.01&q=37.43,-122.17%20(Stanford%20University)&t=h",
        "title": "Stanford University"
      }}>{`Stanford`}</a>{` and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Google_driverless_car"
      }}>{`Google-autonomus-cars`}</a>{` fame is launching `}<a parentName="p" {...{
        "href": "http://www.udacity.com/"
      }}>{`a new class`}</a>{` to teach everyone about creating cars that can drive themselves. Well, to create their brains ... but considering Mythbusters create an RC car every three weeks, the mechanics are probably a solved problem.`}</p>
    <p>{`Having taken the artificial intelligence class last semester, there is no doubt in my mind `}<em parentName="p">{`this class will be `}<strong parentName="em">{`awesome.`}</strong></em>{` The combination of world class professors and an online setting just works so much better than any other class I've been to ... hell I've said before that `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/can-i-please-take-all-my-classes-online/swizec/3147",
        "title": "Can I please take all my classes online?"
      }}>{`I wish all my classes were online`}</a>{` from now on.`}</p>
    <p>{`And the cool thing about Udacity as a whole?`}</p>
    <p>{`They're aiming to revolutionize `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Higher_education",
        "title": "Higher education"
      }}>{`university education`}</a>{`! Starting off with autonomus cars and basic computer science this semester, it will eventually cover the whole computer science spectrum and even provide students with actual certified degrees. Like a "real" university.`}</p>
    <p>{`I wonder how long it will take before I can ratify classes by Sebastian Thrun at my university, but the sooner the better because I expect to be spending much more time on his classes this semester than on most of my `}<em parentName="p">{`real`}</em>{` classes.`}</p>
    <p>{`That said, I'm looking for classmates. Studying is more fun when you can share!`}</p>
    <p>{`Did I mention `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/science-wednesday-self-driving-cars/swizec/3178",
        "title": "Science Wednesday: Self-driving cars"
      }}>{`autonomous cars are super awesome`}</a>{`?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.konstrukshon.com/architectural-technologist-sebastian-thrun-set-up-his-own-free-for-all-university/"
        }}>{`Architectural Technologist - Sebastian Thrun - set up his own, free-for-all university.`}</a>{` (konstrukshon.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://seekerblog.com/2012/02/06/udacity-reinventing-education-2/"
        }}>{`Udacity: Reinventing Education (2)`}</a>{` (seekerblog.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://diyscholar.wordpress.com/2012/01/24/the-audacity-of-udacity/"
        }}>{`The audacity of Udacity`}</a>{` (diyscholar.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.i-programmer.info/news/150-training-a-education/3729-online-computer-science-education-for-free.html"
        }}>{`Online Computer Science Education for Free`}</a>{` (i-programmer.info)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.downes.ca/post/57085/rd"
        }}>{`Stanford AI Professor Thrun Leaves University to Start Udacity, an Online Learning Startup`}</a>{` (downes.ca)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=1f642bbd-5b27-4284-a1a4-4ce27c3d2507",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      